/* @flow */
import { ActionTypes } from 'constants/RoleVerificationConstants';
import Store from 'lib/Store';

class RoleVerificationStore extends Store {
  getInitialState() {
    return {
      roleVerification: null,
    };
  }

  getRoleVerification() {
    return this.state.roleVerification;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.ROLE_VERIFICATION_LOADED:
        this.setState({ roleVerification: action.roleVerification });
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new RoleVerificationStore();



// WEBPACK FOOTER //
// ./src/stores/RoleVerificationStore.js